export default __webpack_public_path__ + "static/media/home-img-hiw.bb405f49.png";